import { accountServiceModule } from '../account-service/account-service';
import { appConfig } from '../../constants/app-config';
import { teamMemberModelModule } from '../../models/team-member';

export const impersonateServiceModule = angular
  .module('Q.services.impersonate-service', [
    accountServiceModule,
    teamMemberModelModule,
  ])

  .factory(
    'impersonateService',
    function ($http, $window, $timeout, $q, TeamMember, accountService) {
      function impersonate(id, mode, url) {
        const data = {
          data: {
            impersonate: id,
          },
        };
        const httpOptions = {
          mode: mode,
        };

        return $http
          .post(`${appConfig.apiRoot}sessions/impersonate`, data, httpOptions)
          .then((resp) => {
            if (
              accountService.get().user &&
              accountService.get().user.$type === resp.data.type
            ) {
              // local impersonation, we'll want to logout first and then log back in
              return accountService.reLogin({
                id: resp.data.id,
                rememberMe: resp.data.rememberMe,
                reload: !url,
              });
            } else {
              // remote impersonation, no need to logout locally
              return accountService.setRemoteAccount(
                resp.data.type,
                resp.data.id,
              );
            }
          })
          .then(() => {
            if (url) {
              $window.location.href = url;
            }
          });
      }

      function isStaff() {
        const user = accountService.get().user || {};
        return user.role === 'staff';
      }

      function impersonateStaff(teamId, url) {
        return TeamMember.findAll({
          teamId: teamId,
          where: { role: 'staff' },
          per: 1,
        })
          .then((teamMembers) => {
            let staffMember = teamMembers[0];
            return staffMember
              ? staffMember.id
              : $q.reject('No staff account available on that team.');
          })
          .then((id) => impersonate(id, undefined, url));
      }

      const baseRoute = `${appConfig.apiRoot}team_members`;

      function switchTeam(teamId, url) {
        return $http
          .post(`${baseRoute}/switch_team`, { teamId })
          .then(({ data }) =>
            accountService.reLogin({ id: data.id, reload: !url }),
          )
          .then(() => {
            if (url) {
              $window.location.href = url;
            }
          });
      }

      return {
        impersonate,
        isStaff,
        impersonateStaff,
        switchTeam,
      };
    },
  );
